import { render, staticRenderFns } from "./SeizedPropertiesSelected.vue?vue&type=template&id=52d6cc9e&scoped=true&"
import script from "./SeizedPropertiesSelected.vue?vue&type=script&lang=js&"
export * from "./SeizedPropertiesSelected.vue?vue&type=script&lang=js&"
import style0 from "./SeizedPropertiesSelected.vue?vue&type=style&index=0&id=52d6cc9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6cc9e",
  null
  
)

export default component.exports